import { render, staticRenderFns } from "./ServidoresOLTManage.vue?vue&type=template&id=19bead70&"
import script from "./ServidoresOLTManage.vue?vue&type=script&lang=js&"
export * from "./ServidoresOLTManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports